// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'lib-flexible'
import store from './store/index'
import { List, Popover } from 'vant'
import { beforeUpload, getUploadThumb, checkImgSize, mattingImgUpload } from './utils/imgtool'
import waterfall from 'vue-waterfall2'
// 复制到粘贴板插件
import VueClipboard from 'vue-clipboard2'
import VueLazyload from 'vue-lazyload'
import { VueHammer } from 'vue2-hammer'
Vue.use(VueLazyload)
Vue.use(VueHammer)
Vue.use(waterfall)
// Vue.use(VueLazyload, {
//   loading: require("路径/加载中图片.png"),
//   error: require("路径/加载失败图片.png")
// })s
Vue.config.productionTip = false
Vue.use(ElementUI)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(List)
Vue.use(Popover)

router.beforeEach((to, from, next) => {
  // 在每次路由切换之前执行
  // 可以决定是否继续路由


  // if (to.name === 'scriptBuild') {
  //   // 判断是否有可以使用的权限 否则不显示
  //   // 非跳转进入
  //   if (from.fullPath === '/') {
  //     next('/')
  //   } else {
  //     // 查看本地保存数据是否允许
  //   }
  // }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  store,
  template: '<App/>'
})
Vue.prototype.$imgzip = beforeUpload
Vue.prototype.$mattingImg = mattingImgUpload
Vue.prototype.$zoomcheck = checkImgSize
Vue.prototype.$getUploadThumb = getUploadThumb



// WEBPACK FOOTER //
// ./src/main.js